<template>
  <!--签章管理-->
  <div class="ent-sign">
    <h1 class="com-title com-ht"><i></i>{{ title }}</h1>
    <div class="box-wrap">
      <div :class="['temone', {active: sealTabItem.signId === item.signId && false}]" v-for="(item, index) in chapterList" :key="index">
        <div class="t-box" @click="sealTabClickFn(item)">
          <!-- 是默认签章-->
          <img
            v-if="item.defaultChapter && item.defaultChapter === 1"
            class="mr-label"
            src="/images/web/icon-default.png"
          />
          <!-- 签章-->
          <img class="y-img" :src="item.signUrl" :title="item.signName"/>
          <div class="msk">
            <div class="list_one left-linear" style="border-bottom: 1px solid">
<!--                           v-if="!(item.defaultChapter && item.defaultChapter === 1)" 已经是默认章了 -->
              <el-tooltip
                effect="light"
                content="设为默认"
                placement="left"
              >
              <span
                class="el-icon-price-tag setting_icon"
                @click="setDefaultSeal(item.signId)"
                title=""
              >
              </span>
              </el-tooltip>
            </div>
            <div class="list_one top-linear" style="border-left: 1px solid">
              <el-tooltip
                effect="light"
                content="修改"
                placement="right"
              >
              <span
                class="el-icon-edit-outline setting_icon"
                style="margin-top: 1px"
                @click="editSign(item)"
                title=""
              ></span>
              </el-tooltip>
            </div>
            <div class="list_one bottom-linear" style="border-right: 1px solid">
              <el-tooltip
                effect="light"
                content="删除"
                placement="left"
              >
              <span
                class="el-icon-delete setting_icon"
                @click="delChapter(item.signId)"
                title=""
              ></span>
              </el-tooltip>
            </div>
            <div class="list_one right-linear" style="border-top: 1px solid; " v-if="!basisVersion">
              <!-- <span>打开后该印章可授权给成员&nbsp;</span>-->
              <el-tooltip
                effect="light"
                content="打开后该印章可授权给成员"
                placement="right"
              >
                <switch-button
                  style="margin: auto"
                  v-model="item.corpSealId"
                  :object="item"
                  @confirmFn="allowToUse"
                ></switch-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div @click="sealTabClickFn(item)">
          <p :title="item.signName">
            {{ item.signName }}
          </p>
          <p :title="`ID:${item.signId}`">
            {{ `ID:${item.signId}` }}
          </p>
        </div>
        <div class="process_auth_btn" v-if="!basisVersion">
          <!--  授权按钮      -->
          <div class="approve_process" v-show="item.corpSealId">
          <div :class="['approve_edit', 'margi_bottom', {'not_active': !authSealList.includes(item.corpSealId)}]" @click="emitAuthListFn(item)">印章授权</div>
          </div>
          <div class="approve_process" v-if="item.corpSealId">
            <div v-if="processTextFn(item)" class="approve_item">
              <div class="info_box">
                <el-popover placement="top-start" trigger="click">
                  <div class="flow_detail">
                    <p>
                      {{
                      !isInDingTalk
                      ? item.flowDetail && item.flowDetail.flowName
                      : isInDingTalk && item.dingTalkFlow
                      ? item.dingTalkFlow.flowName
                      : ""
                      }}
                      <el-button
                        v-if="processTextFn(item)"
                        style="margin-left: 10px"
                        type="primary"
                        size="mini"
                        @click="delShenPi(item)"
                      >取消审批
                      </el-button
                      >
                    </p>
                    <div style="height: 125px;overflow-y:scroll;">
                      <approval-process
                        :flowInfo="computeInfo(item)"
                        :orderFlag="
                        item.flowDetail && !isInDingTalk
                          ? item.flowDetail.orderFlag
                          : item.dingTalkFlow.flowType
                      "
                      ></approval-process>
                    </div>
                  </div>
                  <span class="approve_info" slot="reference">{{
                  !isInDingTalk
                    ? item.flowDetail && item.flowDetail.flowName
                    : item.dingTalkFlow
                    ? item.dingTalkFlow.flowName
                    : ""
                }}</span>
                </el-popover>
              </div>
            </div>
            <!-- <div
              v-else
              :class="['approve_edit', {'not_active': !perms.includes(103)}]"
              @click="editApproveFn(item)"
            >添加用印审批流程</div
            > -->
          </div>
          <!--   高度占位     -->
          <div v-else style="height: 54px">&nbsp;打开印章授权开关后，才可设置授权及流程</div>
        </div>
      </div>
      <!--           trigger="manual"
              v-model="addVisible"-->
      <el-popover
        placement="right"
        width="200"
      >
        <div class="popover-style">
          <el-button size="mini" @click="openFileUploadDialog"
          >本地上传
          </el-button
          >
          <el-button size="mini" @click="makeOnline(false)">在线制作</el-button>
        </div>
        <!-- @click="addSignPup" @blur="addVisible = false"-->
        <div
          slot="reference"
          class="temone add"
        >
          <span class="el-icon-plus"></span>
        </div>
      </el-popover>
    </div>
    <!--签章子系统权限弹窗-->
    <el-dialog
      title="签署配置"
      :visible.sync="dialogVisibleChild"
      :close-on-click-modal="false"
      width="560px"
      class="dialog-child"
    >
      <div class="child-list">
        <template v-if="chapterChildList.length">
          <div
            v-for="(item, index) in chapterChildList"
            :key="index"
            class="text-center list-item"
          >
            <el-checkbox v-model="item.ifUse">{{ item.sourceTag }}</el-checkbox>
          </div>
        </template>
      </div>
      <div slot="footer" class="text-center footer-btn">
        <el-button
          @click="queryChangeChildChapter"
          type="success"
          size="small"
          class="btn"
        >确定
        </el-button
        >
        <el-button
          @click="dialogVisibleChild = false"
          type="danger"
          size="small"
          class="btn"
        >取消
        </el-button
        >
      </div>
    </el-dialog>
    <goto-auth :authDialog.sync="authDialog"></goto-auth>
    <!-- 在线制作印章弹窗 -->
    <!-- v-if="onLineVise" -->
    <sign-on-line
      :onLineVise="onLineVise"
      :signInfo="curretSignInfo"
      @viseControl="onLineVise = !onLineVise"
      @getChapterList="getChapterList"
    ></sign-on-line>
    <!-- 【1714】需求本地上传图片制作印章 -->
    <create-local-seal v-if="isAddSign" :userType="1" :newSign="newSign" @signCreated="signCreated"></create-local-seal>
    <el-dialog title="关联审批" :visible.sync="authDialogVisible" width="45%">
      <p
        style="
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #290202;
          margin-bottom: 10px;
        "
      >
        <i class="warn-img el-icon-warning"></i>
        将印章与用印审批流程关联，使用印章签署文件时需先进行审批
      </p>
      <ul class="liuChengUl">
        <li
          key="9999"
          @click="choosedProcess = {flowId: 'No0'}"
          :style="
            choosedProcess && choosedProcess.flowId == 'No0'
              ? 'background:#f1f1f1'
              : ''
          "
        >
          <img src="../../../static/images/icon/icon-liucheng.jpg" alt=""/>
          无需审批
        </li>
        <li
          v-for="(item, index) in processList"
          :key="index"
          @click="choosedProcess = item"
          :style="
            choosedProcess && choosedProcess.flowId == item.flowId
              ? 'background:#f1f1f1'
              : ''
          "
        >
          <img src="../../../static/images/icon/icon-liucheng.jpg" alt=""/>
          {{ item.flowName }}
          <span v-if="!isInDingTalk" style="font-size: 12px"
          >（{{
              (item.orderFlag ? "顺序审批：" : "会审：") + item.allPartName
            }}）</span
          >
          <span v-else style="font-size: 12px">
            （{{ item.flowType === 1 ? "顺序审批：" : "会审：" }}）
            <template v-if="item.flowType === 1">
              <span v-for="(node, i) of item.nodes" :key="i">
                {{ node.userApproveUsers[0].name }}
                <span v-if="i < item.nodes.length - 1">{{ `->` }}</span>
              </span>
            </template>
            <template v-else>
              <span
                v-for="(node, i) of item.nodes[0].userApproveUsers"
                :key="i"
              >
                {{ node.name }}
                <span v-if="i < item.nodes[0].userApproveUsers.length - 1"
                >、</span
                >
              </span>
            </template>
          </span>
        </li>
      </ul>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="chooseProcess()"
        >确认</el-button
        >
        <el-button size="mini" @click="authDialogVisible = false"
        >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="印章授权" :visible.sync="SealAuth.visi" width="80%">
      <Grant
        :sealInfo="SealAuth.sealInfo"
        @getAuthSealList="getAuthSealList"
        @editApproveFn="editApproveFn"
      ></Grant>
    </el-dialog>
  </div>
</template>

<script>
  import {
    fileOperShow,
    postFileTempUpload
  } from "@/assets/js/http-serve/http-methods";
  import EntSignController from "@/assets/js/http-serve/entSignController";
  import approvalProcess from "@/components/approval-process/index";
  import switchButton from "@/components/switch-button/index";
  import signOnLine from "@/components/tpl-editor/signOnline.vue";
  import createLocalSeal from "../../tpl-editor/localSeal.vue"
  import Grant from "./grant";
  import {getFix} from "@/assets/js/lib/common";
  import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";
  import {isInDingTalk} from "../../../assets/js/utils/ding-env";
  import {dingtalkApi} from '../../../assets/js/http-serve/dingtalkApi';
  import {gantConf, getPermInfo} from "../../../assets/js/utils/jurisdiction";
  import {mapGetters} from "vuex";
  export default {
    data() {
      return {
        SealAuth:{
          visi:false,
          corpSealId:null,
          sealInfo:{},
        }, // 印章授权弹窗
        newSign:null, // 新增的章,用作编辑时回显信息
        sealTabItem: {},
        isInDingTalk,
        authDialogVisible: false,
        processList: [],
        choosedProcess: {},
        signIdSec: "", //流程id

        sealFlowList: [], //章流程列表
        curretSignInfo: {}, // 要编辑的签章
        onLineVise: false, // 在线制作印章窗口
        addVisible: false, // 新增签章选择类型的弹窗
        defalutChapter: {},
        chapterList: [],
        authSealList: [], //已被授权的签章id列表
        // 上传章的参数
        chapterParam: {
          targetId: null,
          targetFix: null,
          signName: null,
          signId: null,
          signUrl: ""
        },
        signNameRules: {
          signName: [
            {
              min: 1,
              max: 50,
              message: "签章名称不能大于50个字符",
              trigger: "change"
            }
          ]
        },
        // 显示上传修改章的弹窗
        isAddSign: false,
        // 签章使用的子系统列表
        chapterChildList: [],
        chapterChaildParam: {signGives: [], signId: null},
        // 签章子系统弹窗显示
        dialogVisibleChild: false,
        loading: null,
        authDialog: false
      };
    },
    mounted() {
      this.getChapterList();
      // this.getProcessList();
    },
    methods: {
      sealTabClickFn(item) {
        this.sealTabItem = item;
      },
      addSignPup() {
        const bool = this.permsEven()
        if (!bool) return
        this.addVisible = !this.addVisible
      },
      /** 权限验证 */
      permsEven(pid = gantConf.enterpriseSealManage) {
        const perms = this.perms;
        const bool = perms.includes(pid);
        if (!bool) {
          const Pinfo = getPermInfo(pid)
          this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
        }
        return bool
      },
      computeInfo(obj) {
        if (!obj) return []
        const {flowDetail: flow, dingTalkFlow: dingFlow} = obj;
        let nameList = [];
        if (!isInDingTalk && flow) nameList = flow.orderFlag ? flow.allPartName.split("->") : flow.allPartName.split("、");
        /*if (obj.orderFlag) {
          nameList = obj.allPartName.split("->");
        } else {
          nameList = obj.allPartName.split("、");
        } */
        if (isInDingTalk && dingFlow) {
          const {nodes} = dingFlow.flowParam;
          nodes && nodes.forEach((node) => {
            nameList.push(...(node.userApproveUsers.map(user => user.name)))
          })
        }
        const list = nameList.map(name => {
          return {
            partyName: name
          };
        });
        return list;
      },
      editApproveFn(item) {
        const bool = this.permsEven()
        if (!bool) return
        this.getProcessList()
        // this.signIdSec = item.signIdSec; //不理解？？？
        this.signIdSec = this.SealAuth.sealInfo.signIdSec;
        this.authDialogVisible = true;
      },
      //添加或取消章流程
      addOrCancelFn(auth, item) {
        let _data = {
          auth: auth,
          signIdSec: item.signIdSec,
          flowId: item.flowId
        }
        if (isInDingTalk) _data.fromDingTalk = 1
        ApiCorpMethods.FlowController.addOrCancelFlow(_data).then(res => {
          if (res.success) {
            this.$message.success("操作成功");
            this.authDialogVisible = false;
            this.getChapterList();
          }else{
            this.$message.error(res.description);
          }
        });
      },
      delShenPi(item) {
        const bool = this.permsEven()
        if (!bool) return
        this.$confirm(`是否取消盖章审核流程？`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.addOrCancelFn(0, item);
          })
          .catch(err => err);
      },
      //添加审批流
      chooseProcess() {
        //无流程走取消审批
        if (this.choosedProcess.flowId === 'No0') {
          const bool = this.permsEven()
          if (!bool) return;
          this.addOrCancelFn(0, {
            signIdSec: this.signIdSec
          });
        } else {
          this.addOrCancelFn(1, {
            ...this.choosedProcess,
            signIdSec: this.signIdSec
          });
        }
      },
      /** 获取审批流列表 */
      getProcessList() {
        if (isInDingTalk) return this.dingProcessList()
        ApiCorpMethods.FlowController.pageFlow({
          itemPage: 1,
          pageSize: 1000,
          flowType: 1
        }).then(res => {
          if (!res.success) return;
          this.processList = res.data.filter(i => +i.useStatus === 0);
        });
      },
      /** 获取钉钉审批流程列表 */
      dingProcessList() {
        const {dingTalkCorpId: corpId, dingTalkUserId} = JSON.parse(
          sessionStorage.getItem("dingloginInfo")
        );
        const param = {
          corpId: corpId,
          dingTalkUserId: dingTalkUserId,
          status: 0,
          useScopeType: 1
        }
        dingtalkApi.workflowList(param).then(res => {
          if (!res.success) return;
          this.processList = res.data
        })
      },
      //流程文字显示
      processTextFn(item) {
        if (!item || (item.flowDetail && item.flowDetail.useStatus !== 0)) return ''
        if (item.flowDetail && !isInDingTalk) {
          return (item.orderFlag ? "顺序审批：" : "会审：") + item.allPartName;
        } else {
          if (item.dingTalkFlow && isInDingTalk) {
            const nodes = item.dingTalkFlow.flowParam.nodes || [];
            let allPartName = '';
            nodes.forEach((elem, i) => {
              elem.userApproveUsers.forEach((vv, vi) => {
                allPartName += (i > 0 || vi > 0) ? `${item.flowType === 1 ? '->' : '、'}${vv.name}` : `${vv.name}`
              })
            });
            return (item.flowType === 1 ? "顺序审批：" : "会审：") + allPartName;
          } else {
            return "";
          }
        }
      },
      //获取章流程
      getSealFlowList(flowId) {
        ApiCorpMethods.SealController.flowInfo({
          flowId: flowId
        }).then(res => {
          if (!res.success) return [];
          return res.data.partyList;
        });
      },
      // 设置默认章
      setDefaultSeal(signId) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.$store.getters.authUser.userType === 0 && !this.perms.includes(103)) {
          return this.$message({
            message: "您当前不能进行默认章设置！",
            type: "warning"
          });
        }
        if (!signId) return false;
        EntSignController.setEntDefaultSeal(signId).then(() => {
          this.getChapterList();
        });
      },
      // 确认修改子系统的签章权限
      queryChangeChildChapter() {
        this.chapterChildList.forEach(t => {
          this.chapterChaildParam.signGives = [];
          if (t.ifUse) {
            this.chapterChaildParam.signGives.push({
              sourceTagId: t.sourceTagId,
              sourceTag: t.sourceTag
            });
          }
        });
        this.chapterChaildParam.signGives = JSON.stringify(
          this.chapterChaildParam.signGives
        );

        this.$confirm("此操作会清空子账户的签章，确定要继续？", "系统提示", {
          type: "info"
        })
          .then(() => {
            EntSignController.giveUpdate(this.chapterChaildParam)
              .then(data => {
                this.dialogVisibleChild = false;
                this.$message({message: "签章配置成功", type: "success"});
              })
              .catch(err => {
                this.dialogVisibleChild = false;
                this.$message({message: err.description, type: "warning"});
              });
          })
          .catch(() => {
          });
      },
      // 权限修改弹窗 获取签章子系统列表
      openChildGetChapChild(signId) {
        this.loadingStart();
        EntSignController.giveList(signId)
          .then(({data}) => {
            this.loadingClose();
            this.chapterChaildParam.signId = signId;
            this.chapterChildList = data;
            this.dialogVisibleChild = true;
          })
          .catch(err => {
            this.loadingClose();
            this.$message({message: err.description, type: "warning"});
          });
      },
      // 允许/禁止成员使用
      allowToUse(corpSealId, item) {
        const bool = this.permsEven()
        if (!bool) return
        if (!item.signId) return false;
        // item.corpSealId 大于0说明是用户是要禁止使用，反之就是允许
        return new Promise((resolve, reject) => {
          let {corpSealId, signId} = item;
          const isUse = corpSealId > 0 ? true : false;
          // "用来判断权限，来显示开启权限后提示信息。有权限，跳转到授权页面。没有就提示成功";
          const confirmText = isUse
            ? "关闭之后将清除该印章已授权的成员和审批流程，是否继续?"
            : "开启成功，是否前往授权？";
          if (!isUse) {
            // 如果是允许使用，则先调用使用接口再弹窗
            this.loadingStart();
            EntSignController.allowMemberUse(signId)
              .then(async res => {
                if (!res.success) return;
                await this.getChapterList();
                // 说明存在权限。可以选择跳转到授权页面 。 反之提示成功
                if (this.perms.includes(gantConf.sealAuth)) {
                  this.$message.success("开启成功");
                } else {
                  this.$message.success("开启成功");
                }
              })
              .catch(err => {
                console.log("err", err);
                this.$message({
                  message: err.description,
                  type: "warning"
                });
              })
              .finally(() => {
                this.loadingClose();
              });
          } else {
            // 关闭
            this.$confirm(confirmText, "系统提示", {
              type: "warning"
            })
              .then(() => {
                // 禁止成员使用
                EntSignController.disableMemberUse(signId).then(res => {
                  if (!res.success) return;
                  this.getChapterList();
                });
                resolve();
              })
              .catch(() => {
                // 点击取消按钮
                reject();
              });
          } // if else end
        });
      },
      emitAuthListFn(seal) {
        if (!seal.corpSealId) {
          return this.$message.error('暂无当前印章管理权限')
        } else if (!this.authSealList.includes(seal.corpSealId)) {
          return this.$message.error('暂无当前印章授权权限')
        } else {
          // 2026-1-15 刘总要求原来的页面改为弹窗
          this.SealAuth.corpSealId = seal.corpSealId;
          this.SealAuth.sealInfo = seal;
          this.SealAuth.visi = true;
        }
      },
      // 删除章
      delChapter(signId) {
        const bool = this.permsEven()
        if (!bool) return
        if (!signId) return;

        this.$confirm(
          "删除之后，该印章将彻底消失，授权的组织成员将无法使用该印章，已发起的合同不受影响，是否继续？",
          "系统提示",
          {
            type: "error"
          }
        )
          .then(() => {
            EntSignController.del(signId)
              .then(data => {
                this.$message({message: "签章删除成功", type: "success"});
                this.getChapterList();
              })
              .catch(data => {
                this.$message({
                  message: data.description || "签章保存失败",
                  type: "warning"
                });
              });
          })
          .catch(() => {
          });
      },
      // 编辑章
      async editSign(sign) {
        const bool = this.permsEven()
        if (!bool) return
        if (sign.productionType == 1) {
          // 在线制作签章的修改
          this.makeOnline(sign);
        } else {
          const bool = await this.permsEven()
          if (!bool) return
          if (this.$store.getters.authUser.identityAuth > -1) {
            this.newSign=sign
            this.addVisible = false;
            this.isAddSign = true;
          } else {
            this.authDialog = true;
          }
          // this.openFileUploadDialog(sign);
        }
      },
      // 在线制作签章
      makeOnline(sign) {
        const bool = this.permsEven()
        if (!bool) return
        // sign false 说明是新增签章。反之就是编辑签章
        if (sign) {
          this.curretSignInfo = sign;
        } else {
          this.curretSignInfo = {};
        }
        this.addVisible = false;
        this.onLineVise = !this.onLineVise;
      },
      // 确认保存章
      queryUploadInfo() {
        if (!this.chapterParam.targetId && this.chapterParam.signId == null)
          return this.$message.error("请上传png格式的图片签章");
        this.$refs.entForm.validate(val => {
          if (val) {
            this.isAddSign = false;
            this.loadingStart();
            EntSignController.update(this.chapterParam)
              .then(data => {
                if (data.success) {
                  this.loadingClose();
                  this.getChapterList();
                  this.$message({message: "签章保存成功", type: "success"});
                } else {
                  throw new Error(data.description);
                }
              })
              .catch(err => {
                this.loadingClose();
                this.$confirm(err.description || "签章保存失败", "系统提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => {
                });
              });
          }
        });
      },
      // 上传章 input上传到临时文件api
      handleInputChange: function (e) {
        e = e.target;
        let param = {file: e.files[0], fileType: 1};

        if (param.file.size > 5 * 1024 * 1024) {
          e.value = "";
          param = {file: "", fileType: 1};

          return this.$confirm(`上传的签章文件不能超过5M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => {
            })
            .catch(() => {
            });
        }

        let {name, fix} = getFix(param.file.name);
        this.chapterParam.signUrl = window.URL.createObjectURL(param.file);
        this.chapterParam.targetFix = fix;
        this.chapterParam.signName = name;

        this.loadingStart();
        postFileTempUpload(param)
          .then(data => {
            this.chapterParam.targetId = data.targetId;
            e.value = "";
            this.loadingClose();
          })
          .catch(err => {
            this.loadingClose();

            e.value = "";
            this.$message(err.description || "上传文件失败");
          });
      },
      // 打开上传新的章或修改章的弹窗
      openFileUploadDialog(chapter = null) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.$store.getters.authUser.identityAuth > -1) {
          this.isAddSign = true;
        } else {
          this.authDialog = true;
        }
      },
      // 创建签章成功
      signCreated(refresh){
        this.isAddSign = false
        this.newSign={}
        if(refresh) this.getChapterList()
      },
      // 弹窗关闭
      handleDialogClosed() {
        this.chapterParam = {
          targetId: null,
          targetFix: null,
          signName: "",
          signId: null,
          signUrl: ""
        };
      },
      //获取已被授权章的列表
      getAuthSealList() {
        ApiCorpMethods.SealController.seals().then(res => {
          if (!res.success) {
            this.$message.error(res.description)
          } else {
            this.authSealList = res.data.map(item => {
              return item.corpSealId;
            });
          }
        });
      },
      // 获取章列表
      getChapterList() {
        this.getAuthSealList(); //跟着所有章列表走不会错，嘿嘿
        this.loadingStart();
        EntSignController.getAll()
          .then(data => {
            let list = data.data;

            if (!data.data || !data.data.length) {
              this.chapterList = [];
            }
            this.defalutChapter = data.data[0];
            list.shift();
            list.forEach(async t => {
              t.signUrl = fileOperShow(t.signUrl);
              if (t.flowId) {
                t.partyList = await this.getSealFlowList(t.flowId);
              } else {
                t.partyList = [];
              }
            });
            list.forEach((t, i) => {
              if (t.defaultChapter && t.defaultChapter === 1) {
                var defSeal = list.splice(i, 1);
                list.unshift(t);
              }
            });
            this.chapterList = list;
            this.sealTabItem = list[0];
            // 更新 SealAuth 中的数据（如果SealAuth.visi 为真）
            if(this.SealAuth.visi){
              const CSeal = list.find(seal=> seal.corpSealId === this.SealAuth.corpSealId)
              if(CSeal) this.SealAuth.sealInfo = CSeal;
            }
            this.loadingClose();
          })
          .catch(() => {
            this.loadingClose();
          });
      },
      loadingStart() {
        this.loadingClose();
        this.loading = this.$loading({
          lock: true
        });
      },
      loadingClose() {
        if (this.loading) this.loading.close();
      }
    },
    components: {
      switchButton,
      signOnLine,
      createLocalSeal,
      approvalProcess,
      Grant,
    },
    computed: {
      ...mapGetters(["currentAuthUser"]),
      perms() {
        return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
      },
      //基础版本
      basisVersion() {
        return this.$store.getters.allAuthUser.accountInfoVO.userType === 1 && this.$store.getters.allAuthUser.accountInfoVO.layoutVersion === 1;
      },
    },
    props: {
      title: {
        type: String,
        default: "我的印章"
      },
    },
    name: "index"
  };
</script>

<style lang="less" scoped>
  .addsign {
    cursor: pointer;
    font-family: Source Han Sans SC;
    font-weight: 700;
    color: #290202;

    &:hover {
      color: #ec1c1c;
    }
  }

  .liuChengUl {
    li {
      margin-bottom: 5px;
      padding: 3px;
      cursor: pointer;

      &.active {
        border-radius: 3px;
        background-color: #eee;
      }

      img {
        vertical-align: unset;
        margin-right: 6px;
      }
    }
  }

  .ent-sign {
    border: 1px solid #f0f0f0;
    background-color: #fff;

    .ent-dialog {
      .sign-tip {
        padding: 20px;
        color: #a1a1a1;
        line-height: 150%;

        ol {
          list-style-position: outside;
          margin-left: 30px;
        }
      }

      .upload-sign {
        position: relative;
        display: block;
        box-sizing: content-box;
        padding: 10px;
        border: 1px dashed #b4b4b4;
        text-align: center;
        color: #a1a1a1;
        overflow: hidden;

        i {
          vertical-align: top;
          color: #333333;
          font-size: 64px;
          font-weight: 600;
          line-height: 90px;
          height: 90px;
        }

        label {
          display: block;
          font-weight: 600;
          font-size: 18px;
          line-height: 1;
          margin-bottom: 5px;
        }

        img {
          max-height: 120px;
          vertical-align: middle;
        }

        input {
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 400px;
          top: -20px;
          left: 0;
          opacity: 0;
          cursor: pointer;
        }
      }

      .ent-form {
        width: 80%;
        margin: 0 auto;
      }
    }

    .box {
      padding: 20px;

      .card {
        width: 250px;
        position: relative;
        margin: 0 auto;

        .seal-type {
          display: inline-block;
          box-sizing: border-box;
          position: absolute;
          top: 10px;
          left: 20px;
          cursor: pointer;
        }

        .add-sign {
          height: 140px;
          line-height: 140px;
          text-align: center;
          cursor: pointer;

          i {
            font-size: 64px;
            vertical-align: middle;
          }
        }

        .bottom {
          padding: 10px 8px;
          background-color: #f8f8f8;
          border-top: 0;
          color: #333;
          font-size: 12px;
          text-align: left;

          .add {
            cursor: pointer;
          }

          .action span {
            margin-left: 5px;
            cursor: pointer;
          }
        }

        .img-box {
          text-align: center;
          height: 140px;
          line-height: 140px;

          img {
            max-height: 90px;
            vertical-align: middle;
          }
        }

        .del-sign {
          display: none;
          position: absolute;
          color: #cccccc;
          right: 5px;
          top: 5px;
          font-size: 18px;
          cursor: pointer;
        }
      }

      .card:hover {
        .del-sign,
        .del-sign:hover {
          display: inline-block;
        }
      }

      p.sign-name {
        width: 250px;
        line-height: 20px;
        height: 20px;
        margin: 5px 0;
      }
    }

    h4 {
      margin: 0;
      padding: 12px;
      background-color: #f8f8f8;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
@tem-width:175px;
  .box-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fill, @tem-width);
    align-items: flex-start;
    justify-items:center;
    justify-content: space-around;
    padding: 15px 20px;

    &:last-child {
      margin-bottom: 130px;
    }

    .temone {
      width: @tem-width;
      margin-bottom: 20px;
      text-align: center;
      align-items: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      height: 90%;
      &.active {
        border: 2px solid #ec1c1c;
      }
      &.add {
        cursor: pointer;
        height: 167px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      p {
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 10px;
        width: 100%;
        font-family: Source Han Sans SC;
        box-sizing: border-box;
        // height: 35px;
        // line-height: 35px;
        background: rgba(239, 239, 239, 1);
        color: rgba(41, 2, 2, 0.65);
      }

      .t-box {
        position: relative;
        width: 100%;
        height: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        &:hover {
          .msk {
            display: flex;
            width: 100%;
            height: 100%;
            opacity: 1;
            // 设置背景颜色以及透明度
            background: rgba(122, 113, 113, 0.35);
            // 背景的模糊大小通过下面的属性值大小来调制
            backdrop-filter: blur(1px);
          }
        }

        .y-img {
          /*width: 106px;*/
          /*min-height: 100px;*/
          width: 96px;
          height: auto;
          display: block;
          margin: 8px auto 7px auto;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;
          z-index: 10;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          align-items: center;
          display: none;
          .list_one {
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
          }
          .left-linear{
            border-image-source: linear-gradient(to left,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .top-linear{
            border-image-source: linear-gradient(to top,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .bottom-linear{
            border-image-source: linear-gradient(to bottom,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .right-linear{
            border-image-source: linear-gradient(to right,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .center-linear{
            border-image-source: linear-gradient(to bottom,transparent,#ccc, #ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          span {
            cursor: pointer;
            float: right;
            color: #ffffff;
            font-size: 20px;
            width: 50%;
            &:hover {
              color: rgba(236, 28, 28, 1);
            }
          }

          .setmr-btn {
            float: left;
            font-size: 14px;
            margin-left: 0;
          }
        }

        .mr-label {
          position: absolute;
          left: 0;
          top: 0;
          font-size: 12px;
          color: rgba(236, 28, 28, 1);
          z-index: 5;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
      .process_auth_btn {
        padding: 8px 3px;
        .approve_process {
          width: 100%;
          text-align: left;

          .approve_item {
            display: flex;
            align-items: center;
            justify-content:center;
            padding: 1px 0;
          }

          .approve_info {
            cursor: pointer;
            font-weight: bold;
          }

          .edit_text {
            width: 31%;
          }

          .info_box {
            // width: 68%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .approve_edit {
            border: 1px solid #290202;
            border-radius: 4px;
            font-size: 12px;
            color: #290202;
            cursor: pointer;
            padding: 2px 6px;
            text-align: center;
            &:hover {
              color: #ffffff;
              background-color: #ec1c1c;
              border: 1px solid #ec1c1c;
            }
            &.not_active {
              border: 1px solid #c0c0c0;
              color: #c0c0c0;
              &:hover {
                color: #ffffff;
                background-color: #c0c0c0;
                border: 1px solid #c0c0c0;
              }
            }
            &.margi_bottom {
              margin-bottom: 6px;
              text-align: center;
            }
          }
        }
      }
    }
  }

  .flow_detail {
    padding: 10px;
    font-weight: bold;
  }

  .popover-style {
    height: 100px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    /deep/ .el-button + .el-button {
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// components/console/seal/mySign.vue